export * from './settings.types';
export * from './useDefaultLocale';
export * from './useSettings';

export const LOGOUT_TRIGGERS = [
  'auth_error_token_expired',
  'organization_contract_not_set',
  'organization_contract_expired',
];
